import { CALENDAR_EVENT_TYPES } from '@/app/(main)/calendar/consts/calendar-event-types';
import type { CalendarEvent } from '@/types/calendarTypes';

export type BirthdayDayGroup = {
  dateKey: string;
  birthdays: CalendarEvent[];
};

function getBirthdayDateKey(event: CalendarEvent): string {
  return event.start.slice(0, 10);
}

export function groupBirthdaysByDay(events: CalendarEvent[]): {
  nonBirthdayEvents: CalendarEvent[];
  birthdayGroups: BirthdayDayGroup[];
} {
  const nonBirthdayEvents: CalendarEvent[] = [];
  const groupsByDate = new Map<string, CalendarEvent[]>();

  for (const event of events) {
    if (event.type !== CALENDAR_EVENT_TYPES.BIRTHDAY) {
      nonBirthdayEvents.push(event);
      continue;
    }

    const dateKey = getBirthdayDateKey(event);
    const existing = groupsByDate.get(dateKey);

    if (existing) {
      existing.push(event);
    } else {
      groupsByDate.set(dateKey, [event]);
    }
  }

  const birthdayGroups: BirthdayDayGroup[] = [];

  for (const [dateKey, birthdays] of groupsByDate) {
    birthdayGroups.push({ dateKey, birthdays });
  }

  return { nonBirthdayEvents, birthdayGroups };
}
